<script setup>
defineProps({
  products: {
    type: Array,
    required: true,
  },
  features: {
    type: Array,
    required: true,
  },
  currentPlanId: {
    type: String,
    default: 'free',
  },
});

const featureValue = (feature, planId) => feature[planId];
</script>

<template>
  <div class="overflow-x-auto">
    <table class="w-full text-sm border rounded-lg border-n-weak">
      <thead>
        <tr class="border-b border-n-weak">
          <th class="p-3 text-left text-n-slate-11">
            {{ $t('QUICK_SETUP.STEP_PLAN.FEATURE') }}
          </th>
          <th
            v-for="product in products"
            :key="product.id"
            class="p-3 text-left text-n-slate-12"
          >
            {{ product.name }}
            <span
              v-if="currentPlanId === product.id"
              class="ml-1 text-xs text-n-teal-11"
            >
              {{ $t('QUICK_SETUP.STEP_PLAN.CURRENT') }}
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="feature in features"
          :key="feature.label"
          class="border-b border-n-weak last:border-0"
        >
          <td class="p-3 text-n-slate-11">{{ feature.label }}</td>
          <td v-for="product in products" :key="product.id" class="p-3">
            <span v-if="typeof featureValue(feature, product.id) === 'boolean'">
              <span
                :class="
                  featureValue(feature, product.id)
                    ? 'i-lucide-check text-n-teal-11'
                    : 'i-lucide-x text-n-slate-9'
                "
              />
            </span>
            <span v-else>{{ featureValue(feature, product.id) }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
